{
  "tabs": {
    "chat": "Чат",
    "reminders": "Напамінкі",
    "calendar": "Каляндар",
    "settings": "Настройкі"
  },
  "common": {
    "cancel": "Адмяніць",
    "save": "Захаваць",
    "confirm": "Пацвердзіць",
    "delete": "Выдаліць",
    "back": "Назад",
    "close": "Закрыць",
    "edit": "Рэдагаваць",
    "search": "Пошук",
    "all": "Усе",
    "loading": "Загрузка...",
    "error": "Штосьці пайшло не так",
    "notFound": "Не знойдзена",
    "tryAgain": "Калі ласка, паспрабуйце зноў",
    "retry": "Паспрабаваць зноў",
    "undo": "Адмяніць",
    "pullToRefresh": "Пацягніце для абнаўлення",
    "justNow": "толькі што"
  },
  "auth": {
    "welcome": "Сардэчна запрашаем у FishMemory",
    "tagline": "Ваш памочнік напамінкаў у WhatsApp, цяпер у вашым кішэні.",
    "subtitle": "Ваш памочнік напамінкаў у WhatsApp, цяпер у вашым кішэні.",
    "phoneLabel": "Ваш нумар WhatsApp",
    "phoneHint": "Мы вышлем код пацверджання праз WhatsApp",
    "invalidPhone": "Калі ласка, увядзіце сапраўдны нумар тэлефона",
    "continue": "Працягнуць",
    "enterPhone": "Увядзіце ваш нумар WhatsApp",
    "phonePlaceholder": "Нумар тэлефона",
    "sendCode": "Адправіць код",
    "verifyTitle": "Пацвердзіце ваш нумар",
    "otpSentTo": "6-значны код адпраўлены на {{phone}} праз WhatsApp",
    "enterFullCode": "Калі ласка, увядзіце ўсе 6 лічбаў",
    "invalidOtp": "Няправільны код. Калі ласка, паспрабуйце зноў.",
    "otpFailed": "Не ўдалося адправіць код. Паспрабуйце зноў.",
    "otpResent": "Код адпраўлены паўторна",
    "resendIn": "Паўторна адпраўляць праз {{seconds}} с",
    "resendCode": "Адправіць код паўторна",
    "enterOtp": "Увядзіце код, адпраўлены на ваш WhatsApp",
    "verify": "Пацвердзіць",
    "resend": "Адправіць код паўторна",
    "wrongNumber": "Няправільны нумар?",
    "backToPhone": "Назад да нумара",
    "editPhone": "Рэдагаваць нумар тэлефона",
    "error": "Памылка",
    "setupTitle": "Давайце наладзім",
    "setupSubtitle": "Вы заўсёды можаце змяніць гэта пазней у Настройках",
    "namePlaceholder": "Ваша імя",
    "letsGo": "Завяршыць наладу",
    "skipForNow": "Прапусціць пакуль"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Увядзіце паведамленне...",
    "inputPlaceholder": "Увядзіце паведамленне...",
    "typing": "FishMemory піша...",
    "online": "У сетцы",
    "connecting": "Падключэнне...",
    "reconnecting": "Перападключэнне...",
    "offline": "Афлайн",
    "empty": "Пачніце размову",
    "emptyHint": "Стварайце напамінкі, правярайце расклад або прасіць дапамогу.",
    "emptyAction": "Адправіць прыклад напамінку",
    "actions": "Дзеянні ў чаце",
    "keep": "Захаваць паведамленні",
    "clearTitle": "Ачысціць чат",
    "clearConfirm": "Выдаліць усе паведамленні з гэтага прылады? Гэта нельга адмяніць.",
    "clear": "Ачысціць чат",
    "optionSelected": "Выбрана: {{label}}",
    "sendingSelection": "Адпраўка...",
    "connectionLost": "Перападключэнне..."
  },
  "reminders": {
    "title": "Мае напамінкі",
    "active": "Актыўныя",
    "today": "Сёння",
    "thisWeek": "Гэты тыдзень",
    "history": "Гісторыя",
    "items": "пункты",
    "emptyTitle": "Пакуль няма напамінкаў",
    "emptySubtitle": "Стварыце адзін у чаце, і ён з'явіцца тут.",
    "emptyAction": "Адкрыць чат",
    "filterActive": "Актыўныя",
    "filterToday": "Сёння",
    "filterWeek": "Гэты тыдзень",
    "filterHistory": "Гісторыя",
    "emptyState": "Пакуль няма напамінкаў. Пачніце чат!",
    "swipeDone": "Гатова",
    "swipeSnooze": "Адкласці",
    "swipeDelete": "Выдаліць",
    "search": "Пошук напамінкаў...",
    "upcoming": "Набліжаюцца",
    "completed": "Завершаныя",
    "overdue": "Пратэрмінаваныя",
    "tomorrow": "Заўтра",
    "synced": "Сінхранізавана {{value}}",
    "swipeHint": "Перацягніце напамін для дадатковых дзеянняў",
    "noResults": "Напамінкі не адпавядаюць пошуку",
    "noResultsHint": "Паспрабуйце іншае слова або ачысціце пошук",
    "deleteAllFailed": "Не ўдалося выдаліць усе напамінкі"
  },
  "calendar": {
    "title": "Каляндар",
    "today": "Сёння",
    "tomorrow": "Заўтра",
    "completed": "зроблена",
    "noEvents": "Нічога не запланавана",
    "noEventsSubtitle": "Выберыце дату, каб убачыць напамінкі і падзеі календара.",
    "googleEvent": "Google Calendar",
    "legendActive": "Актыўныя",
    "legendRecurring": "Паўтаральныя",
    "legendDone": "Зроблена",
    "legendGoogle": "Google",
    "previousMonth": "Мінулы месяц",
    "nextMonth": "Наступны месяц",
    "previousYear": "Мінулы год",
    "nextYear": "Наступны год",
    "goToToday": "Перайсці да сёння",
    "all": "Усе",
    "active": "Актыўныя",
    "done": "Зроблена",
    "paused": "Паўза"
  },
  "settings": {
    "title": "Настройкі",
    "profile": "Профіль",
    "name": "Імя для паказу",
    "enterName": "Увядзіце імя",
    "language": "Мова",
    "uiLanguage": "Мова прыкладання",
    "uiLanguageHelp": "Змяняе мову інтэрфейсу, пазнакі календара і кірунак макета толькі на гэтым прыладзе.",
    "serverLanguage": "Мова чату",
    "serverLanguageHelp": "Змяняе мову адказаў сервера і паведамленняў напамінкаў для вашага акаўнта.",
    "timezone": "Часавы пояс",
    "currentTimezone": "Бягучы часавы пояс",
    "timezoneHelp": "Усе часы напамінкаў паказваюцца з улікам гэтага часовага пояса.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Захаваць часавы пояс",
    "timezoneSaved": "Часавы пояс абноўлены",
    "detect": "Вызначыць",
    "detectFailed": "Не ўдалося вызначыць часавы пояс",
    "autoDetect": "Аўтаматычна па GPS",
    "notifications": "Апавяшчэнні",
    "notificationsHelp": "Паўторныя напамінкі кантралююць паўторныя апавяшчэнні пасля дастаўкі напамінку. Дазволы на ўзроўні прылады кіруюцца ў наладах тэлефона.",
    "pushEnabled": "Пуш-апавяшчэнні",
    "autoDoneOnFire": "Аўтаматычна адзначаць выкананым пры спрацоўванні",
    "autoDoneOnFireDesc": "Калі адключана, напамінкі застаюцца актыўнымі, пакуль вы іх не адзначыце.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Падключана",
    "googleDisconnected": "Не падключана",
    "googleConnectedHelp": "Новыя напамінкі могуць аўтаматычна сінхранізавацца з вашым календаром.",
    "googleDisconnectedHelp": "Падключыце Google Calendar, каб сінхранізаваць напамінкі і падзеі.",
    "googleConnectFailed": "Не ўдалося падключыць Google Calendar",
    "connected": "Падключана",
    "disconnected": "Не падключана",
    "connect": "Падключыць",
    "disconnect": "Адключыць",
    "autoSync": "Аўта-сінхранізацыя новых напамінкаў",
    "autosync": "Аўта-сінхранізацыя новых напамінкаў",
    "subscription": "Падпіска",
    "trialUsed": "Прабны перыяд: выкарыстана {{used}}/{{total}}",
    "trialStatus": "Прабны перыяд даступны",
    "activeStatus": "Актыўная падпіска",
    "expiredStatus": "Падпіска скончылася",
    "unsubscribedStatus": "Не падпісаны",
    "about": "Пра праграму",
    "version": "Версія",
    "logout": "Выйсці",
    "logoutTitle": "Выйсці",
    "logoutConfirm": "Вы ўпэўненыя, што хочаце выйсці?",
    "noName": "Імя не ўстаноўлена",
    "serverConnection": "Падключэнне да сервера",
    "serverUrl": "URL сервера",
    "serverEdit": "Рэдагаваць",
    "saveReconnect": "Захаваць і перападключыцца",
    "resetDefault": "Скінуць па змаўчанні",
    "invalidServerUrlTitle": "Няправільны URL сервера",
    "invalidServerUrlMessage": "Увядзіце сапраўдны URL сервера http або https, напрыклад https://example.com",
    "uiLanguageChangeFailed": "Не ўдалося змяніць мову прыкладання. Калі ласка, паспрабуйце зноў.",
    "serverLanguageChangeFailed": "Не ўдалося змяніць мову чату. Калі ласка, паспрабуйце зноў.",
    "timezoneChangeFailed": "Не ўдалося змяніць часавы пояс. Калі ласка, паспрабуйце зноў.",
    "autoSyncChangeFailed": "Не ўдалося абнавіць аўта-сінхранізацыю. Калі ласка, паспрабуйце зноў.",
    "nameChangeFailed": "Не ўдалося абнавіць імя для паказу. Калі ласка, паспрабуйце зноў.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Дэталі напамінку",
    "editTime": "Рэдагаваць час",
    "rename": "Перайменаваць",
    "snooze": "Адкласці",
    "snooze15": "Адкласці на 15 хвілін",
    "pause": "Паўза",
    "pauseReminder": "Паставіць напамін на паўзу",
    "resume": "Працягнуць",
    "resumeReminder": "Працягнуць напамін",
    "skip": "Прапусціць наступны",
    "skipOccurrence": "Прапусціць гэты выпадак",
    "syncGoogle": "Сінхранізаваць з Google",
    "delete": "Выдаліць",
    "deleteTitle": "Выдаліць напамін",
    "deleteConfirm": "Гэты напамін будзе выдалены назаўсёды.",
    "deleteRecurringTitle": "Выдаліць паўтаральны напамін",
    "deleteRecurringMessage": "Вы хочаце прапусціць гэты выпадак або выдаліць усю серыю?",
    "deleteThisOccurrence": "Прапусціць гэты выпадак",
    "deleteEntireSeries": "Выдаліць усю серыю",
    "done": "Гатова",
    "markDone": "Адзначыць як выканана",
    "undo": "Адмяніць",
    "undoPrompt": "Патрэбна зноў актываваць? Адмяніце зараз.",
    "recurring": "Паўтаральны",
    "nextRun": "Наступны запуск",
    "oneTime": "Адзін раз",
    "pending": "У чаканні",
    "sent": "Адпраўлена",
    "paused": "Паўза",
    "active": "Актыўны",
    "snoozed": "Адкладзены",
    "localTime": "Паказваецца ў вашым мясцовым часе",
    "recurrence": "Паўтарэнне",
    "created": "Створаны",
    "tags": "Тэгі",
    "fireCount": "Колькасць спрацоўванняў",
    "actions": "Дзеянні",
    "none": "Няма",
    "snoozeFailed": "Не ўдалося адкласці напамін",
    "pauseFailed": "Не ўдалося паставіць напамін на паўзу",
    "resumeFailed": "Не ўдалося працягнуць напамін",
    "skipFailed": "Не ўдалося прапусціць напамін",
    "doneFailed": "Не ўдалося адзначыць напамін як выкананы",
    "undoFailed": "Не ўдалося аднавіць статус напамінку",
    "deleteFailed": "Не ўдалося выдаліць напамін",
    "rescheduleTitle": "Перапланаваць?",
    "rescheduleMsg": "Гэты напамін пратэрмінаваны. Хочаце перапланаваць?",
    "reschedule15": "Праз 15 хвілін",
    "reschedule60": "Праз 1 гадзіну",
    "keepOverdue": "Пакінуць як ёсць"
  },
  "onboarding": {
    "slide1Title": "Сардэчна запрашаем у FishMemory",
    "slide1Sub": "Ваш асабісты памочнік напамінкаў — на базе WhatsApp і створаны для вашага кішэні.",
    "slide2Title": "Проста пішыце натуральна",
    "slide2Sub": "Уводзьце напамінкі так, як думаеце: «Нагадай мне патэлефанаваць маме заўтра ў 15:00» — мы зробім астатняе.",
    "slide3Title": "Ніколі нічога не прапусціце",
    "slide3Sub": "Атрымлівайце своечасовыя апавяшчэнні, арганізоўвайце з дапамогай тэгаў і кантралюйце ўсё важнае.",
    "getStarted": "Пачаць",
    "next": "Далей",
    "firstReminderTitle": "Стварыце першы напамін!",
    "firstReminderHint": "Паспрабуйце ўвесці нешта накшталт:",
    "firstReminderExample": "Нагадай мне выпіць вады заўтра ў 9 раніцы",
    "gotIt": "Зразумела!",
    "notifRationaleTitle": "Будзьце своечасовымі",
    "notifRationaleBody": "FishMemory патрэбны апавяшчэнні, каб нагадаць вам своечасова. Вы будзеце атрымліваць апавяшчэнні толькі для створаных вамі напамінкаў.",
    "notifRationaleAllow": "Уключыць апавяшчэнні",
    "notifRationaleLater": "Магчыма пазней",
    "swipeHint": "Права для хуткіх дзеянняў →",
    "calendarDragHint": "Цягніце для пашырэння ↕"
  }
}
